"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _reactBootstrap = require("react-bootstrap");
var _richTextField = require("../../lib/richTextField");
var _lodash = require("lodash");
var _titleHeadTag = require("../../lib/titleHeadTag");
var _index = _interopRequireDefault(require("../../renderings/CardLinkList/index"));
var _index2 = _interopRequireDefault(require("../../renderings/HorizontalCard/index"));
var _index3 = _interopRequireDefault(require("../../renderings/MediaCard/index"));
var _index4 = _interopRequireDefault(require("../../renderings/MediaHorizontalCard/index"));
var _index5 = _interopRequireDefault(require("../../renderings/VerticalCard/index"));
var _index6 = _interopRequireDefault(require("../../renderings/LoginCard/index"));
var _index7 = _interopRequireDefault(require("../../renderings/ContactCard/index"));
var _index8 = _interopRequireDefault(require("../../renderings/CallOutCard/index"));
var _index9 = _interopRequireDefault(require("../../renderings/Accordion/index"));
var _VideoPlayer = _interopRequireDefault(require("../../renderings/VideoPlayer"));
var _BackgroundCard = _interopRequireDefault(require("../../renderings/BackgroundCard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A list of cards
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A React Element
 */
function CardList(props) {
  var _extractedFields$Head;
  if (!props.rendering.fields) return null;
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var cardPlacement = (0, _lodash.isEmpty)(extractedFields.CardPlacement.value) ? 'horizontal' : extractedFields.CardPlacement.value;
  var alignmentParamKey = (_extractedFields$Head = extractedFields.HeaderAlignment) !== null && _extractedFields$Head !== void 0 && _extractedFields$Head.fields.Key.value ? extractedFields.HeaderAlignment.fields.Key.value : 'Center';
  var clsName = alignmentParamKey === 'Center' ? 'mm-text-center' : "".concat(extractedFields.HeaderAlignment.fields.Value.value);
  var perRowItemCount = extractedFields.MaxCardsPerRow.value == null || extractedFields.MaxCardsPerRow.value == '' ? 4 : extractedFields.MaxCardsPerRow.value;
  var colSize = extractedFields.CardList.length < perRowItemCount ? (0, _utils.columnWidth)(extractedFields.CardList.length, 12 / perRowItemCount) : 12 / perRowItemCount;
  var cardListArray = extractedFields.CardList.reduce((resultArray, item, index) => {
    var chunkIndex = Math.floor(index / perRowItemCount);
    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []; // start a new chunk
    }
    resultArray[chunkIndex].push(item);
    return resultArray;
  }, []);
  var LoadComponent = props => {
    switch (props.rendering.fields.CardType.value) {
      case 'accordion':
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          className: "".concat(cardPlacement === 'horizontal' ? "col-12 col-md-".concat(colSize) : '')
        }, /*#__PURE__*/_react.default.createElement(_index9.default, {
          rendering: props.rendering,
          params: props.params
        }));
      case 'callout':
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          xs: 12,
          md: colSize
        }, /*#__PURE__*/_react.default.createElement(_index8.default, {
          rendering: props.rendering,
          params: props.params
        }));
      case 'horizontalWithLinks':
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "".concat(cardPlacement === 'horizontal' ? "col-sm-12 col-md-".concat(colSize) : 'col')
        }, /*#__PURE__*/_react.default.createElement(_index.default, {
          rendering: props.rendering,
          params: props.params
        }));
      case 'contact':
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          xs: 12,
          md: colSize
        }, /*#__PURE__*/_react.default.createElement(_index7.default, {
          rendering: props.rendering,
          params: props.params
        }));
      case 'horizontalBasic':
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          sm: 12,
          md: "".concat(cardPlacement === 'horizontal' ? colSize : '')
        }, /*#__PURE__*/_react.default.createElement(_index2.default, {
          rendering: props.rendering,
          params: props.params,
          imageColSize: 5,
          bodyColSize: 7
        }));
      case 'login':
        if (cardPlacement === 'horizontal') {
          return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
            xs: 12,
            sm: 12,
            md: colSize
          }, /*#__PURE__*/_react.default.createElement(_index6.default, {
            rendering: props.rendering,
            params: props.params
          }));
        } else {
          return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_index6.default, {
            rendering: props.rendering,
            params: props.params
          }));
        }
      case 'media':
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          className: "".concat(cardPlacement === 'horizontal' ? "custom-contact col-sm-12 col-md-".concat(colSize) : '')
        }, /*#__PURE__*/_react.default.createElement(_index3.default, {
          rendering: props.rendering,
          params: props.params
        }));
      case 'mediaHorizontalCard':
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          className: "".concat(cardPlacement === 'horizontal' ? "custom-contact col-sm-12 col-md-".concat(colSize) : '')
        }, /*#__PURE__*/_react.default.createElement(_index4.default, {
          rendering: props.rendering,
          params: props.params
        }));
      case 'vertical':
        var vCardParams = props.params;
        vCardParams.ImgHeight = extractedFields.VerticalCardImgHeight.value;
        if (cardPlacement === 'horizontal') {
          return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
            xs: 12,
            md: colSize,
            className: "align-self-stretch",
            key: props.index
          }, /*#__PURE__*/_react.default.createElement(_index5.default, {
            rendering: props.rendering,
            params: vCardParams
          }));
        } else {
          return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_index5.default, {
            rendering: props.rendering,
            params: vCardParams
          }));
        }
      case 'video':
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          className: "".concat(cardPlacement === 'horizontal' ? "col-12 col-md-".concat(colSize) : '')
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "card no-border"
        }, /*#__PURE__*/_react.default.createElement(_VideoPlayer.default, {
          rendering: props.rendering,
          params: props.params
        })));
      case 'backgroundCard':
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement("div", {
          className: "card no-border"
        }, /*#__PURE__*/_react.default.createElement(_BackgroundCard.default, {
          rendering: props.rendering,
          params: props.params
        })));
      default:
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          sm: 12,
          md: "".concat(cardPlacement === 'horizontal' ? colSize : '')
        }, /*#__PURE__*/_react.default.createElement("div", null));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: 'app-container'
  }, !(0, _lodash.isEmpty)(extractedFields.Header.value) && (0, _titleHeadTag.headTagTitle)(extractedFields.Header, "".concat(clsName, " mm-spacing--minor"), extractedFields.HeaderSize.value), !(0, _lodash.isEmpty)(extractedFields.PreviewText.value) && /*#__PURE__*/_react.default.createElement("div", null, (0, _richTextField.parseHTML)(extractedFields.PreviewText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "card-list ".concat(cardPlacement)
  }, (0, _lodash.map)(cardListArray, (rowArray, rowKey) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(cardListArray.length - 1 === rowKey ? 'row' : 'row mm-spacing--minor'),
      key: rowKey
    }, (0, _lodash.map)(rowArray, (comp, compkey) => {
      var propRendering = {
        fields: comp.fields,
        dataSource: comp.id
      };
      return /*#__PURE__*/_react.default.createElement(LoadComponent, {
        key: compkey,
        index: compkey,
        rendering: propRendering,
        params: props.params
      });
    }));
  })));
}
var _default = exports.default = CardList;